import { faCalendarDays, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Button, Col, Form, Modal, Nav, Row, Tab } from "react-bootstrap";

const FilterModal = (props) => {
    const [searchInput, setSearchInput] = useState("");
    const handleChange = (e) => {
        setSearchInput(e.target.value);
    };

    return (
        <div>
            <Modal show={props.show} onHide={props.close} centered className="filter_modal">
                <Modal.Header closeButton>
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="filter_details">
                        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                            <Row>
                                <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="first">Patient Status</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="second">Ward</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="third">Admission Date</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="fourth">Task status</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="fifth">Date</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="sixth">Sort By</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={8}>
                                    <div className="content_area">
                                        <Tab.Content>
                                            <Tab.Pane eventKey="first">
                                                <Form className="patient_form">
                                                    <Form.Check
                                                        type="checkbox"
                                                        id="Admitted"
                                                        label="Admitted"
                                                    />
                                                    <Form.Check
                                                        type="checkbox"
                                                        id="Critical"
                                                        label="Critical"
                                                    />
                                                    <Form.Check
                                                        type="checkbox"
                                                        id="UnderTreatment"
                                                        label="Under Treatment"
                                                    />
                                                </Form>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="second">
                                                {/* <div className="search_details"> */}
                                                <Form className="ward_form">
                                                    <Form.Group className="form-group">
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="No Selected"
                                                            value={searchInput}
                                                            onChange={handleChange}
                                                        />
                                                        <a href="javascript:;">
                                                            <div className="icon">
                                                                <FontAwesomeIcon icon={faSearch} />
                                                            </div>
                                                        </a>
                                                    </Form.Group>
                                                    <Form.Check
                                                        type="checkbox"
                                                        id="Admitted"
                                                        label="Admitted"
                                                    />
                                                    <Form.Check
                                                        type="checkbox"
                                                        id="Critical"
                                                        label="Critical"
                                                    />
                                                    <Form.Check
                                                        type="checkbox"
                                                        id="UnderTreatment"
                                                        label="Under Treatment"
                                                    />
                                                </Form>
                                                {/* </div> */}

                                            </Tab.Pane>
                                            <Tab.Pane eventKey="third">
                                                <Form className="admission_date_form">
                                                    <Form.Group controlId="fromDate" className="form-group">
                                                        <Form.Label>From<span>*</span></Form.Label>
                                                        <Form.Control type="text" placeholder="Ex. 12 June, 2023" />
                                                        <div className="icon">
                                                            <FontAwesomeIcon icon={faCalendarDays} />
                                                        </div>
                                                    </Form.Group>
                                                    <Form.Group controlId="toDate" className="form-group">
                                                        <Form.Label>to<span>*</span></Form.Label>
                                                        <Form.Control type="text" placeholder="Ex. 12 June, 2023" />
                                                        <div className="icon">
                                                            <FontAwesomeIcon icon={faCalendarDays} />
                                                        </div>
                                                    </Form.Group>
                                                </Form>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="fourth">
                                                <Form className="task_status_form">
                                                    <Form.Check
                                                        type="checkbox"
                                                        id="CompletedTasks"
                                                        label="Completed tasks"
                                                    />
                                                    <Form.Check
                                                        type="checkbox"
                                                        id="PendingTasks"
                                                        label="Pending tasks"
                                                    />
                                                    <Form.Check
                                                        type="checkbox"
                                                        id="ProgressTasks"
                                                        label="Progress tasks"
                                                    />
                                                    <Form.Check
                                                        type="checkbox"
                                                        id="CancelTasks"
                                                        label="Cancel tasks"
                                                    />
                                                </Form>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="fifth">
                                                <Form className="admission_date_form">
                                                    <Form.Group controlId="fromDate" className="form-group">
                                                        <Form.Label>From<span>*</span></Form.Label>
                                                        <Form.Control type="text" placeholder="Ex. 12 June, 2023" />
                                                        <div className="icon">
                                                            <FontAwesomeIcon icon={faCalendarDays} />
                                                        </div>
                                                    </Form.Group>
                                                    <Form.Group controlId="toDate" className="form-group">
                                                        <Form.Label>to<span>*</span></Form.Label>
                                                        <Form.Control type="text" placeholder="Ex. 12 June, 2023" />
                                                        <div className="icon">
                                                            <FontAwesomeIcon icon={faCalendarDays} />
                                                        </div>
                                                    </Form.Group>
                                                </Form>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="sixth">
                                                <Form className="sort_form">
                                                    <Form.Select>
                                                        <option disabled selected>Select</option>
                                                        <option>Time Alloted</option>
                                                        <option>Task Priority</option>
                                                        <option>Task Status</option>
                                                    </Form.Select>
                                                </Form>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Container>
                        <div className="btn_area">
                            <Button className="cancelBtn" type="button" onClick={props.close}>Cancel</Button>
                            <Button className="submitBtn" type="submit">Apply</Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default FilterModal;